import { render } from "./InterviewCandidacyComment.vue?vue&type=template&id=98036a8a"
import script from "./InterviewCandidacyComment.vue?vue&type=script&lang=js"
export * from "./InterviewCandidacyComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__